// extracted by mini-css-extract-plugin
export default {"gridBox":"footer_gridBox__DGxZJ","flexBox":"footer_flexBox__H9bBs"};